"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var getScrollbarWidth_1 = __importDefault(require("../scroll/getScrollbarWidth"));
var getPositionOrder_1 = __importDefault(require("./getPositionOrder"));
var calculatePosition_1 = __importDefault(require("./calculatePosition"));
var isFullyVisible_1 = __importDefault(require("./isFullyVisible"));
var constants_1 = require("./constants");
/**
 * Set position of the target element to fit on the screen
 */
var getInBoundsPosition = function (origin, target, options) {
    var position = options.position, forcePosition = options.forcePosition, zIndex = options.zIndex;
    var targetClone = target.cloneNode(true);
    // Reset all styles applied on the previous hook execution
    targetClone.removeAttribute("style");
    Object.keys(constants_1.RESET_STYLES).forEach(function (key) {
        var value = constants_1.RESET_STYLES[key];
        targetClone.style[key] = value.toString();
    });
    if (options.container) {
        options.container.appendChild(targetClone);
    }
    else {
        document.body.appendChild(targetClone);
    }
    var originBounds = origin.getBoundingClientRect();
    var targetBounds = targetClone.getBoundingClientRect();
    if (options.container) {
        var containerBounds = options.container.getBoundingClientRect();
        var scrollbarWidth = (0, getScrollbarWidth_1.default)();
        var hasVerticalScrollbar = options.container.scrollHeight > options.container.clientHeight;
        var containerLeft = options.rtl && hasVerticalScrollbar
            ? containerBounds.left + scrollbarWidth
            : containerBounds.left;
        originBounds = __assign({
            top: originBounds.top,
            right: originBounds.right,
            bottom: originBounds.bottom,
            left: originBounds.left,
            width: originBounds.width,
            height: originBounds.height,
            x: originBounds.x,
            y: originBounds.y,
        }, { top: originBounds.top - containerBounds.top, right: originBounds.left - containerLeft + originBounds.width, bottom: originBounds.top - containerBounds.top + originBounds.height, left: originBounds.left - containerLeft });
    }
    var order = (0, getPositionOrder_1.default)(position);
    var mobileOrder = order.filter(function (position) { return position === "top" || position === "bottom"; });
    var calculated = (0, calculatePosition_1.default)(originBounds, targetBounds, options);
    var test = function (items, extraOptions) {
        items.some(function (currentPosition) {
            var tested = (0, calculatePosition_1.default)(originBounds, targetBounds, __assign(__assign(__assign({}, options), extraOptions), { position: currentPosition, zIndex: zIndex }));
            if ((0, isFullyVisible_1.default)(tested.styles, options.container) ||
                (
                // We're ok with the first option after we got to mobile if that position if forced
                extraOptions === null || extraOptions === void 0 ? void 0 : extraOptions.mobileFallback)) {
                calculated = tested;
                return true;
            }
            return false;
        });
    };
    if (!(0, isFullyVisible_1.default)(calculated.styles, options.container) && !forcePosition) {
        test(order);
        // Second run to prioritize mobile positions
        // for not-fitting content
        if (!(0, isFullyVisible_1.default)(calculated.styles, options.container)) {
            test(mobileOrder, { mobileFallback: true });
        }
    }
    targetClone.parentNode.removeChild(targetClone);
    return calculated;
};
exports.default = getInBoundsPosition;
